// assets
import { ChromeOutlined, QuestionOutlined,MenuOutlined,PlusCircleOutlined } from '@ant-design/icons';

const icons = {
  ChromeOutlined,
  QuestionOutlined,
  MenuOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'support',
  title: 'Support',
  type: 'group',
  children: [
    // {
    //   id: 'sample-page',
    //   title: 'Sample Page',
    //   type: 'item',
    //   url: '/dashboard/sample-page',
    //   icon: PlusCircleOutlined
    // },
   
  ]
};

export default support;
